import type { ChipColor } from '@/types/chip';
import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { TrendingDown } from '@mui/icons-material';

export const CERTIFICATION_TYPES = ['First Aid L1', 'First Aid L2', 'OHS Representative', 'Fire Safety', 'Food Safety', 'Hazmat'];
export const CERTIFICATION_STATUS = ['Active', 'Expired', 'Pending Renewal'];
export const INCIDENT_SEVERITY = ['Minor', 'Major', 'Fatal'];
export const INCIDENT_STATUS = ['Reported', 'Investigating', 'Closed', 'Disputed'];
export const REPRESENTATIVE_STATUS = ['Active', 'Expired', 'Pending Training'];
export const EVENT_TYPES = ['Evacuation Drill', 'H&S Meeting', 'Fire Extinguisher Check', 'First Aid Training', 'OHS Training', 'Inspection'];
export const SEVERITY_COLORS: Record<string, string> = { Minor: 'success.main', Major: 'warning.main', Fatal: 'error.main' };
export const STATUS_COLORS: Record<string, ChipColor> = { Active: 'success', Expired: 'error', 'Pending Training': 'warning', Pending: 'default' };

export const ExpirySparkline = ({ expiryDate, issueDate }: { expiryDate: string; issueDate: string }) => {
  const [now] = useState(() => Date.now());
  const expiry = new Date(expiryDate).getTime();
  const certified = new Date(issueDate).getTime();
  const totalDuration = expiry - certified;
  const remaining = expiry - now;
  const daysRemaining = Math.ceil(remaining / (1000 * 60 * 60 * 24));
  const pctRemaining = Math.max(0, Math.min(100, (remaining / totalDuration) * 100));

  const getColor = () => {
    if (daysRemaining <= 0) return 'error';
    if (daysRemaining <= 30) return 'error';
    if (daysRemaining <= 60) return 'warning';
    return 'success';
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 120 }}>
      <Box sx={{ flex: 1, position: 'relative' }}>
        <Box sx={{ height: 8, bgcolor: 'grey.200', borderRadius: 1, overflow: 'hidden' }}>
          <Box
            sx={{
              width: `${pctRemaining}%`,
              height: '100%',
              bgcolor: `${getColor()}.main`,
              borderRadius: 1,
              transition: 'width 0.3s ease',
            }}
          />
        </Box>
        <Box sx={{ position: 'absolute', right: 0, top: -2 }}>
          <TrendingDown sx={{ fontSize: 12, color: `${getColor()}.main` }} />
        </Box>
      </Box>
      <Typography variant="caption" sx={{ minWidth: 40, textAlign: 'right', color: `${getColor()}.main`, fontWeight: 600 }}>
        {daysRemaining <= 0 ? 'Expired' : `${daysRemaining}d`}
      </Typography>
    </Box>
  );
};
